import { Logo } from "@allaria-tech/matter/Logo";

import { PartnerConsentFlow } from "../../utils/partnerConsent";

import styles from "./PartnerConsentPage.module.scss";

interface Props {
  flow: PartnerConsentFlow;
}

/**
 * Host + partner lockup heading every screen; the page's own navigation bar,
 * which is why Layout's header stands down. The host side comes from the flow,
 * not the build's company, so it can't drift with VITE_COMPANY.
 */
const PartnerConsentBanner = ({ flow }: Props) => {
  const { banner, partnerLogo } = styles;

  return (
    <div className={banner}>
      <Logo product={flow.host.logo} />
      {flow.logo && (
        <img
          className={partnerLogo}
          src={flow.logo}
          alt={`${flow.name} logo`}
        />
      )}
    </div>
  );
};

export default PartnerConsentBanner;
